module.exports = __webpack_public_path__ + "static/media/logo.d820ee72.svg";